export default __webpack_public_path__ + "static/LyneHOME-9b99b1bbaab6317a162af79f4533670d.png";